import { render, staticRenderFns } from "./RightOne.vue?vue&type=template&id=620e6938"
import script from "./RightOne.vue?vue&type=script&lang=js"
export * from "./RightOne.vue?vue&type=script&lang=js"
import style0 from "./RightOne.vue?vue&type=style&index=0&id=620e6938&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports